const RH_INSURANCE_PHONE_NUMBER = '18886161868';
const CIS_PHONE_NUMBER = '18664386587';

export {
    CIS_PHONE_NUMBER,
    RH_INSURANCE_PHONE_NUMBER,
};
